import React from 'react';

import { rsvpInfoBlock } from './EditPagesInfoBlock';
import {
  tipsHome,
  tipsEvent,
  tipsWeddingParty,
  tipsTravel,
  tipsPhoto,
  tipsPOI,
  PageTips,
} from './EditPagesTips';

const EDIT_PAGES_CONTENT = {
  HOME: {
    title: 'Home',
    dek:
      'Welcome guests with photos, stories about you two, and more. You can play around and preview updates as you go.',
    tips: PageTips(tipsHome),
  },
  EVENT: {
    title: 'Schedule',
    dek:
      'From welcome drinks to the ceremony and farewell brunch, lay out the weekend’s schedule of events, so guests know where to go and when.',
    tips: PageTips(tipsEvent),
  },
  WEDDING_PARTY: {
    title: 'Wedding Party',
    dek:
      'Introduce your guests to the special people who will be standing next to you two on your big day.',
    tips: PageTips(tipsWeddingParty),
  },
  TRAVEL: {
    title: 'Travel',
    dek:
      'Will guests need to fly out to your wedding? Do you have any hotel blocks reserved? What about shuttles? Share all that info here.',
    tips: PageTips(tipsTravel),
  },
  REGISTRY: {
    title: 'Registry',
    dek: {
      hasZolaRegistry: (
        <>
          Let guests easily shop your Zola registry on your website. When ready,{' '}
          <strong>set this page to &quot;Active&quot;</strong> — and make sure your Zola registry is
          visible to guests.
        </>
      ),
      noZolaRegistry:
        'Meet Zola Registry: One store with all the gifts couples want. Smart tools that save you time. Unlimited access to one-on-one support.',
    },
  },
  PHOTO: {
    title: 'Photos',
    dek:
      'Get everyone excited to celebrate with tons of beautiful photos. The more you share, the happier the guests.',
    tips: PageTips(tipsPhoto),
  },
  POI: {
    title: 'Things To Do',
    dek:
      "List all the restaurants, activities, and more that you don't want your guests to miss while they're in town.",
    tips: PageTips(tipsPOI),
  },
  FAQ: {
    title: 'FAQs',
    dek:
      'Try to avoid those day-of texts and calls from guests. Give them all the info they need in a helpful question-and-answer section.',
  },
  RSVP: {
    title: 'RSVP',
    dek: 'Let guests easily RSVP on your website to your wedding events.',
    infoBlock: rsvpInfoBlock,
  },
};

export default EDIT_PAGES_CONTENT;



// WEBPACK FOOTER //
// ./src/constants/EditPagesContent/EditPagesContent.jsx